export const NEW_CERTIFICATE = "v2/certificates/new-certificate"
export const MY_CERTIFICATE = "v2/certificates/my-certificate"